export const onKeyPress = (editor) => (event) => {
  event.stopPropagation();
  return;
};
